import { _callBackend } from './api';
import type { APIRequest, APIResponsePromise } from '@/_types/api';

export const generateClientReport = async ({
  token,
}: APIRequest): APIResponsePromise =>
  await _callBackend('/reports/generate_client_list', 'GET', null, token);

export const generateEntityReport = async ({
  token,
}: APIRequest): APIResponsePromise =>
  await _callBackend('/reports/generate_entity_list', 'GET', null, token);

export const generateConversationReport = async ({
  token,
  start_date,
  end_date,
}: APIRequest<{
  start_date: string | undefined;
  end_date: string | undefined;
}>): APIResponsePromise => {
  let endpoint = '/reports/generate_entity_list_with_conversation';
  if (start_date && end_date) {
    endpoint = `${endpoint}?start_date=${start_date}&end_date=${end_date}`;
  }
  return await _callBackend(endpoint, 'GET', null, token);
};

export const generateDeliveryReport = async ({
  token,
}: APIRequest): APIResponsePromise =>
  await _callBackend('/reports/generate_delivery_report', 'GET', null, token);

export const generateQuestionnaireReport = async ({
  token,
  year,
}: APIRequest<{
  year: number;
}>): APIResponsePromise =>
  await _callBackend(
    `/reports/generate_questionnaire_report?year=${year}`,
    'POST',
    null,
    token,
  );

export const generateNearlyCompletedQuestionnaireList = async ({
  token,
  year,
  percentage,
}: APIRequest<{
  year: number;
  percentage: number;
}>): APIResponsePromise =>
  await _callBackend(
    `/reports/generate_nearly_finished_questionnaire_report?year=${year}&percentage=${percentage}`,
    'POST',
    null,
    token,
  );

export const generateUnseenMessageList = async ({
  token,
}: APIRequest): APIResponsePromise =>
  await _callBackend(
    '/reports/generate_unseen_messages_report',
    'GET',
    null,
    token,
  );

export const generateUnattachedDocumentList = async ({
  token,
}: APIRequest): APIResponsePromise =>
  await _callBackend(
    '/reports/generate_unattached_documents_report',
    'GET',
    null,
    token,
  );

export const getCreditUsage = async ({
  token,
  year,
}: APIRequest<{
  year: number;
}>): APIResponsePromise =>
  await _callBackend(
    `/reports/get_credit_usage?tax_year=${year}`,
    'GET',
    null,
    token,
  );

export const generateUsageReport = async ({
  token,
  year,
}: APIRequest<{
  year: number;
}>): APIResponsePromise =>
  await _callBackend(
    `/reports/generate_usage_report?year=${year}`,
    'GET',
    null,
    token,
  );

export const generateRolloverItemsReport = async ({
  token,
  year,
}: APIRequest<{
  year: number;
}>): Promise<{
  data: {
    link: string;
  };
  error: string;
}> =>
  await _callBackend(
    `/reports/generate_prior_year_information_report?year=${year}`,
    'POST',
    null,
    token,
  );
